<script lang="ts">
  // Render a "before $min–$max → after $min–$max" diff for a loan
  // purpose's amount_range, muting the half (min or max) that did
  // not change. The reviewer's eye is drawn to the moved end of the
  // range rather than re-reading two near-identical strings — same
  // pattern the rate-cube delta table uses for unchanged columns
  // ("—" for the field whose value did not move).
  //
  // The component handles the four cases the proposal flow surfaces:
  //   - add: only `after` is present.
  //   - remove: only `before` is present.
  //   - update where both ends moved: render the full diff.
  //   - update where only one end moved: mute the unchanged half on
  //     both sides of the arrow.

  import { formatAmount } from '../lib/formatters';

  interface AmountRange {
    min: number;
    max: number;
  }

  interface Props {
    before?: AmountRange | null;
    after?: AmountRange | null;
  }

  const { before, after }: Props = $props();

  const minChanged = $derived(
    before !== null && before !== undefined && after !== null && after !== undefined && before.min !== after.min
  );
  const maxChanged = $derived(
    before !== null && before !== undefined && after !== null && after !== undefined && before.max !== after.max
  );
</script>

{#if !before && after}
  ${formatAmount(after.min)}&ndash;${formatAmount(after.max)}
{:else if before && !after}
  ${formatAmount(before.min)}&ndash;${formatAmount(before.max)}
{:else if before && after}
  {#if !minChanged && !maxChanged}
    ${formatAmount(after.min)}&ndash;${formatAmount(after.max)}
  {:else}
    {#if minChanged}${formatAmount(before.min)}{:else}<span class="muted">${formatAmount(before.min)}</span>{/if}&ndash;{#if maxChanged}${formatAmount(before.max)}{:else}<span class="muted">${formatAmount(before.max)}</span>{/if}
    &rarr;
    {#if minChanged}${formatAmount(after.min)}{:else}<span class="muted">${formatAmount(after.min)}</span>{/if}&ndash;{#if maxChanged}${formatAmount(after.max)}{:else}<span class="muted">${formatAmount(after.max)}</span>{/if}
  {/if}
{:else}
  —
{/if}
